import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import About from '@/components/About'
import Program from '@/components/Program'
import Events from '@/components/Events'
import Skitfaced from '@/components/Skitfaced'
import Current from '@/components/Current'
import UploadSkitfaced from '@/components/Content/UploadSkitfaced'
import Contact from '@/components/Contact'
import Participate from '@/components/Participate'
import Opportunities from '@/components/Opportunities'
import Slowbart from '@/components/Slowbart'
import LibertyLoop from '@/components/LibertyLoop'
import WeAreOne from '@/components/WeAreOne'
import Involved from '@/components/Involved'
import Contents from '@/components/Content/Contents'
import Playlist from '@/components/Content/Playlist'
import Submissions from '@/components/Submissions'
import Schedule from '@/components/Content/Schedule'
import UploadContent from '@/components/Content/UploadContent'
import UploadNew from '@/components/Content/UploadNew'
import Profile from '@/components/User/Profile'
import Controls from '@/components/Control/Controls'
import Colour from '@/components/Play/Colour'
import WebCam from '@/components/Play/WebCam'
import Volume from '@/components/Play/volume'
import Pixel from '@/components/Play/Pixel'
import Signup from '@/components/User/Signup'
import Signin from '@/components/User/Signin'
import AuthGuard from './auth-guard'
import AdminGuard from './admin-guard'


Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'Home',
      component: Home
    },
   { path: '/home',
      name: 'Home2',
      component: Home
    },
    {
      path: '/program',
      name: 'Program',
      component: Program
    },
    {
      path: '/submissions',
      name: 'Submissions',
      component: Submissions
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/participate',
      name: 'Participate',
      component: Participate
    },
    {
      path: '/opportunities',
      name: 'Opportunities',
      component: Opportunities
    },
    {
      path: '/slowbart',
      name: 'Slowbart',
      component: Slowbart
    },
    {
      path: '/libertyloop',
      name: 'LibertyLoop',
      component: LibertyLoop
    },
    {
      path: '/weareone',
      name: 'WeAreOne',
      component: WeAreOne
    },
    {
      path: '/events',
      name: 'Events',
      component: Events
    },
    {
      path: '/current',
      name: 'Current',
      component: Current
    },
    {
      path: '/skitfaced',
      name: 'Skitfaced',
      component: Skitfaced
    },
    {
      path: '/uploadskitfaced',
      name: 'UploadSkitfaced',
      component: UploadSkitfaced
    },

    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/involved',
      name: 'Involved',
      component: Involved
    },
    {
      path: '/content',
      name: 'Contents',
      component: Contents,
      beforeEnter: AdminGuard
    },
    {
      path: '/playlist',
      name: 'Playlist',
      component: Playlist,
      beforeEnter: AdminGuard
    },
    {
      path: '/schedule',
      name: 'Schedule',
      component: Schedule,
      beforeEnter: AdminGuard
    },
    {
      path: '/content/new',
      name: 'UploadContent',
      component: UploadContent,
      beforeEnter: AuthGuard
    },
    {
      path: '/content/new2',
      name: 'UploadNew',
      component: UploadNew
    },
    {
      path: '/controls',
      name: 'Controls',
      component: Controls,
      beforeEnter: AdminGuard
    },

    {
      path: '/play/colour/:mode',
      name: 'Colour',
      component: Colour
    },
    {
      path: '/colour',
      name: 'Colour',
      component: Colour
    },
    {
      path: '/play/colour',
      name: 'Colour2',
      component: Colour
    },
    {
      path: '/play/webcam',
      name: 'WebCam2',
      component: WebCam
    },
    {
      path: '/play/volume',
      name: 'Volume',
      component: Volume
    },
    {
      path: '/pixel',
      name: 'Pixel',
      component: Pixel
    },
    {
      path: '/play/pixel',
      name: 'Pixel2',
      component: Pixel
    },
    {
      path: '/play/pixel/:mode',
      name: 'Pixel2m',
      component: Pixel
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      beforeEnter: AuthGuard
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup
    },
    {
      path: '/signin',
      name: 'Signin',
      component: Signin
    }
  ],
  mode: 'history'
})


// WEBPACK FOOTER //
// ./src/router/index.js